// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/scripts/" + chunkId + "-" + "a48feff0f14bbb8db33c" + ".js";
};